import React, { FC } from 'react';
import { TextField, TextFieldProps } from '@material-ui/core';

interface IMTableFilterComponent {
  onChange: (value: string | number) => void;
}

const MTableFilterComponent: FC<
  IMTableFilterComponent & Omit<TextFieldProps, 'onChange'>
> = (props) => {
  const { onChange } = props;

  const handleChange = (
    event: React.ChangeEvent<{ value: string | number }>,
  ) => {
    onChange(event.target.value);
  };

  return <TextField {...props} fullWidth onChange={handleChange} />;
};

export default MTableFilterComponent;
